import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StepsSeparated from './components/StepsSeparated';
import Upload from './components/Upload';
import Complete from './components/Complete';

function App() {
  return (
    <div className="App">
      <h1>OCR Refinement Editor</h1>
      <Router>
        <Routes>
          <Route path="/" element={<StepsSeparated />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/complete" element={<Complete />} />
        </Routes>
        <p>Release Version: {process.env.REACT_APP_RELEASE_TIME} {process.env.REACT_APP_RELEASE_MODE}</p>
      </Router>
    </div>
  );
}

export default App;
